import {
    Breadcrumb,
    BreadcrumbItem,
    BreadcrumbLink,
    Stack,
} from '@chakra-ui/react';
import { Link } from 'react-router-dom';

import {
    Alert,
    AlertDescription,
    AlertIcon,
    Button,
    Heading,
} from 'components/v4';
import { breadCrumbTrail, addHeader as header } from './constants';

import {
    breadCrumbStyling,
    headingStyling,
} from 'components/forms/new/formStyles';

const NoRegistrar = ({ onClick }) => {
    return (
        <>
            <Breadcrumb sx={breadCrumbStyling}>
                {breadCrumbTrail?.map((crumb, index) => (
                    <BreadcrumbItem key={index}>
                        {Array.isArray(crumb.path) ? (
                            <BreadcrumbLink
                                as={Link}
                                to={crumb.path[0]}
                                state={crumb.path[1]}>
                                {crumb.label}
                            </BreadcrumbLink>
                        ) : (
                            <BreadcrumbLink as={Link} to={crumb.path}>
                                {crumb.label}
                            </BreadcrumbLink>
                        )}
                    </BreadcrumbItem>
                ))}
            </Breadcrumb>
            <Stack>
                <Heading sx={headingStyling}>{header}</Heading>
            </Stack>
            <Stack spacing={30} maxW={895}>
                <Alert status="info">
                    <AlertIcon />
                    <AlertDescription>
                        There is no registrar available to create a TRS
                        Registration.
                    </AlertDescription>
                </Alert>

                <div
                    className="edit-form-buttons"
                    style={{
                        border: 'none',
                        textAlign: 'left',
                        marginTop: 0,
                        paddingTop: '15px',
                    }}>
                    <Button
                        type="submit"
                        className="h-10 min-w-[5rem] font-semibold disabled:cursor-not-allowed"
                        sx={{ width: 142 }}>
                        <Link
                            style={{
                                textDecoration: 'none',
                                color: 'inherit',
                            }}
                            to="/pbx">
                            To Registrar
                        </Link>
                    </Button>

                    <div
                        style={{
                            marginLeft: 30,
                            display: 'inline',
                        }}>
                        <Button
                            className="secondary h-10 min-w-[5rem] font-semibold"
                            variant="outline"
                            sx={{ width: 142 }}
                            onClick={onClick}>
                            Back
                        </Button>
                    </div>
                </div>
            </Stack>
        </>
    );
};

export { NoRegistrar };
